<template>
  <img
    :class="{ 'tg-logo': !isLogin, 'to-login-logo': isLogin }"
    :src="`/logo/${site}.png`"
    :alt="site"
  />
</template>

<script>
export default {
  name: "TgLogo",
  props: {
    site: String,
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.tg-logo {
  height: 70px;
  width: 70px !important;
  margin-top: 18px;
}

.to-login-logo {
  width: 210px;
  height: 144px;
  position: absolute;
  top: -75px;
  left: 105px;
}
</style>
